import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AppLoader from '../components/common/AppLoader/AppLoader';
import { useNzJourneyStatus } from '../hooks/useNzJourneyStatus';
import { useLoadPsychologist } from './useLoadPsychologist';

/** Lo que dura como mínimo la pantalla de carga: la misma que en la web (`OnboardingRedirect`), para que se vea la animación. */
export const BOOT_MIN_MS = 2500;
/** Tope de espera: si los datos no llegaron (sin red, error), se entra igual — nunca queda trabada en la carga. */
export const BOOT_MAX_MS = 5000;

/** La carga se muestra UNA vez por apertura de la app: volver a `/` navegando no la repite. */
let bootDone = false;

/** Solo para los tests: vuelve a la "primera apertura". */
export function resetBootForTests(): void {
  bootDone = false;
}

/**
 * Pantalla de carga de la app mobile (`/`): la misma de la web (`AppLoader`, "Preparando plataforma…"). La app abría directo en la
 * Agenda, con la pantalla en blanco mientras cargaba la psicóloga. Mientras se muestra, ya se carga su perfil; al terminar entra a la
 * Agenda (`/calendar`), conservando el query (`?view=`, `?session=`…).
 */
export function PwaBoot() {
  const { search } = useLocation();
  const { loading } = useNzJourneyStatus();
  const [minElapsed, setMinElapsed] = useState(bootDone);
  const [timedOut, setTimedOut] = useState(bootDone);
  useLoadPsychologist();

  useEffect(() => {
    if (bootDone) return;
    const min = setTimeout(() => setMinElapsed(true), BOOT_MIN_MS);
    const max = setTimeout(() => setTimedOut(true), BOOT_MAX_MS);
    return () => {
      clearTimeout(min);
      clearTimeout(max);
    };
  }, []);

  const ready = bootDone || (minElapsed && (!loading || timedOut));
  useEffect(() => {
    if (ready) bootDone = true;
  }, [ready]);

  if (!ready) return <AppLoader />;
  return <Navigate to={`/calendar${search}`} replace />;
}
